import { postGetTranslations } from '../../apis/translations';

export async function fetchProductTranslations() {

    const translationKeys = {
        ListPrice: 'ProjectBuilder.Label.ListPrice',
        Discontinued: 'Product.Label.Discontinued',
        NewReplacement: 'Product.Btn.NewReplacement',
        UnauthenticatedPriceMessage: 'Product.Label.UnauthenticatedPriceMessage',
        MSRP: 'ProjectBuilder.Label.MSRP'
    }

    return postGetTranslations(Object.values(translationKeys))
        .then((translations) => {
            return {
                ListPrice: translations[translationKeys.ListPrice] ?? 'List price',
                Discontinued: translations[translationKeys.Discontinued] ?? 'Discontinued',
                NewReplacement: translations[translationKeys.NewReplacement] ?? <span>View New Replacement Product</span>,
                UnauthenticatedPriceMessage: translations[translationKeys.UnauthenticatedPriceMessage] ?? 'Sign in to see price',
                MSRP: translations[translationKeys.MSRP] ?? 'MSRP'
            }
        })
        .catch((error) => {
            console.error('Error fetching translations:', error);
            return {
                ListPrice: 'List price',
                Discontinued: 'Discontinued',
                NewReplacement: <span>View New Replacement Product</span>,
                UnauthenticatedPriceMessage: 'Sign in to see price',
                MSRP: 'MSRP'
            }
        });
}